export enum OrderType {
  ALEKS_SHARPEN_COMPANION = 'HE-aleks-sharpen-companion',
  BOARDS_AND_BEYOND_ORDER_TYPE = 'professional-faf-bab',
  CONNECT_BUNDLE_SHARPEN = 'HE-connect-sharpen',
  CONNECT_BUNDLE_SHARPEN_ADVANTAGE = 'HE-connect-sharpen-advantage',
  CONNECT_BUNDLE_SHARPEN_COMPANION = 'HE-connect-sharpen-companion',
  HE_CONNECT = 'HE-connect',
  HE_CREATE = 'he-create',
  HE_CUSTOM_STORE = 'he-custom-store',
  HE_NATIONAL = 'he-national',
  K12_STOREFRONT = 'k12-storefront',
  PROFESSIONAL = 'professional',
  SEG_NATIONAL = 'seg-national',
}
